import React, { useEffect, useState } from "react";
import { getPurchaseDetails } from "@/services/students/getPurchaseDetails";
import ButtonComponent from "@/components/button/Button";
import { getProductById } from "@/services/common/getProductById";
import IconTick from "@/components/icons/IconTick";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsMiniDashboardOpen } from "@/reducers/commonSlice";
import { getUniqueObjects } from "@/helpers";
import Slider from "react-slick";
import "@/styles/components/purchaseCard.scss";
const settings = {
  infinite: false,
  slidesToShow: 1,
};

const PurchaseCard = () => {
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigate = () => {
    navigate("/plans");
    dispatch(setIsMiniDashboardOpen(false));
  };
  useEffect(() => {
    getPurchaseDetails().then((res) => {
      res?.map(async (x) => {
        getProductById(x.productId)
          .then((plan) => {
            setPurchaseDetails((prevstate) => [...prevstate, plan]);
          })
          .catch((err) => console.log(err));
      });
    });
  }, []);

  return (
    <div className="purchase-details">
      {purchaseDetails.length ? (
        <Slider {...settings}>
          {getUniqueObjects(purchaseDetails)?.map((purchase, i) => {
            return (
              <div className="visa-content" key={i}>
                <div className="heading-card body-b1">{purchase.title}</div>
                {purchase?.offerings.map((item, i) => {
                  return (
                    <div className="including body-b4 flex" key={i}>
                      <IconTick /> {item}
                    </div>
                  );
                })}
                {/* <div className="content body-b4">
          End-to-end visa process assistance for studying abroad.
        </div> */}
              </div>
            );
          })}
        </Slider>
      ) : (
        <></>
      )}
      <div className="explore-button">
        <ButtonComponent label="Explore Other Plans & Offerings" onClick={handleNavigate} />
      </div>
    </div>
  );
};

export default PurchaseCard;
